<div class="container" >
<header >
    <app-header></app-header>
</header>
<main>

    <router-outlet></router-outlet>
</main>
<footer>
<app-footer></app-footer>
</footer>
</div>  
<a class="whatsapp-float"
   href="https://wa.me/524924934968?text=Hola%20%2C%20tengo%20dudas%20para%20adquirir%20un%20instrumento."
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Contactar soporte pre-venta por WhatsApp">
    <i class='bx bxl-whatsapp'></i>
</a>
<app-cookie-consent></app-cookie-consent>
